import React from 'react';

const HeaderSlider = (props) => {

    return (
        <>
            <div className="image-wrapper">
                <img src={props.src} alt="banner" />
                <div className="header-overlay banner-heading">{props.title}</div>
            </div>
        </>
    )
}

export default HeaderSlider;